module.exports = __webpack_public_path__ + "2897eaaa97018f192e1ba400531163a5.jpg";